const styles = (theme) => ({
  menuItem: {
    padding: "10px 15px 8px 15px",
    "&:hover": {
      backgroundColor: "#ebebeb",
    },
    borderRadius: "8px 8px 0px 0px",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "1.25",
    textAlign: "center",
    color: "#2a292a",
    cursor:"pointer",
    fontFamily:"Open sans",
    marginRight:"8px",
    display:"flex",
    position: "relative",
  },
  selectedItemMenu:{
    backgroundColor: "#ebebeb",
    borderBottom:`solid 4px ${theme.palette.primary.main}`,
  },
  downIcon:{
    fontSize:"24px",
  },
  subMenuItem:{
    color: "#4a4a4a",
    fontSize:"14px",
  }
});

export default styles;
